import SmallCenteredTextComponent from '@components/SmallCenteredText';
import { IPrismicRichText } from '@monofront/types';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapSmallCenteredText } from './mapSmallCenteredText';

const SmallCenteredText: React.FC<IPrismicRichText> = (text) => {
  if (!text) {
    return null;
  }

  return <SmallCenteredTextComponent text={text} />;
};

export default withSlice(SmallCenteredText, mapSmallCenteredText);
